import ExpandMoreRoundedIcon from '@mui/icons-material/ExpandMoreRounded';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Grid,
  Stack,
  Typography,
} from '@mui/material';
import getSymbolFromCurrency from 'currency-symbol-map';
import { useState } from 'react';
import useOrderDetails from '../../../../hooks/project/useOrderDetails';
import BrandIcon from '../../../utils/common/BrandIcon';
import PaymentMethodIcon from '../../../utils/common/PaymentMethodIcon';
import PaymentStatusIcon from '../../../utils/common/PaymentStatusIcon';
import ShipperIcon from '../../../utils/common/ShipperIcon'; // Import du nouveau composant
import ShippingStatusIcon from '../../../utils/common/ShippingStatusIcon';
import OrderDetails from './OrderDetails.jsx';

const Order = (props) => {
  const { order } = props;
  const [openDetails, setOpenDetails] = useState(false);
  const { orderDetails } = useOrderDetails(openDetails ? order?._id : null);

  const handleOpenOrderDetails = () => {
    setOpenDetails(!openDetails);
  };

  return (
    <Box>
      <Accordion
        elevation={18}
        disableGutters
        expanded={openDetails}
        sx={[
          order?.status?.code === 'CANCELED_BY_SC' && {
            backgroundColor: '#ffebee',
            '& .MuiAccordionSummary-root': {
              opacity: 0.8,
            },
          },
        ]}
      >
        <AccordionSummary
          expandIcon={
            <ExpandMoreRoundedIcon onClick={() => handleOpenOrderDetails()} />
          }
          sx={{
            userSelect: 'text',
          }}
        >
          <Box sx={{ flexGrow: 1 }}>
            <Grid
              container
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
              }}
            >
              <Grid>
                <BrandIcon
                  brand={order?.contact?.store?.brand?.name}
                  type={order?.contact?.store?.contactType?.codeBO}
                  style={{ width: 'inherit', height: '32' }}
                />
              </Grid>
              <Grid>
                <Typography component={'span'} fontSize={14}>
                  {order?.type?.name}
                </Typography>
              </Grid>
              <Grid sx={{ display: 'flex', flexDirection: 'column' }}>
                <Typography
                  component={'span'}
                  fontSize={12}
                  sx={{
                    whiteSpace: 'nowrap',
                  }}
                >
                  {order?.reference}
                </Typography>
                {order?.mpId && (
                  <Typography
                    component={'span'}
                    fontSize={12}
                    sx={{
                      whiteSpace: 'nowrap',
                    }}
                  >
                    {order?.mpId}
                  </Typography>
                )}
              </Grid>
              <Grid sx={{ display: 'flex' }}>
                <ShipperIcon shipper={order?.shipper} size={24} />
                <Stack direction="row" spacing={1} alignItems="center">
                  <ShippingStatusIcon orderStatus={order?.status?.name} />
                </Stack>
              </Grid>
              <Grid
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                }}
              >
                <Typography
                  component={'span'}
                  fontSize={14}
                  sx={[
                    {
                      flexWrap: 'nowrap',
                    },
                    order?.status?.code === 'CANCELED_BY_SC' && {
                      textDecoration: 'line-through',
                    },
                  ]}
                >
                  {order?.price?.toFixed(2)}
                  {getSymbolFromCurrency(order?.currency?.code)}
                </Typography>
                <PaymentMethodIcon paymentmethod={order?.paymentMethod} />
                <PaymentStatusIcon paymentStatus={order?.paymentStatus} />
              </Grid>
              <Grid>
                <Typography
                  component={'span'}
                  fontSize={12}
                  sx={{
                    whiteSpace: 'nowrap', // Empêche le retour à la ligne
                    overflow: 'hidden', // Cache le texte qui dépasse
                    textOverflow: 'ellipsis', // Affiche des points de suspension si trop long
                    width: '100%', // Assure que l'élément utilise tout l'espace disponible
                  }}
                >
                  {new Date(
                    order?.dates?.approvedAt ||
                      order?.dates?.createdAt ||
                      order?.createdAt
                  ).toLocaleString('fr-FR', {
                    year: 'numeric',
                    month: 'short',
                    day: 'numeric',
                    hour: 'numeric',
                    minute: 'numeric',
                  })}
                </Typography>
              </Grid>
            </Grid>
          </Box>
        </AccordionSummary>
        <AccordionDetails>
          <OrderDetails
            order={order}
            openDetails={openDetails}
            orderDetails={orderDetails}
          />
        </AccordionDetails>
      </Accordion>
    </Box>
  );
};

export default Order;
